(function (window, document) {
  'use strict';

  var config = window.AlAsilGoogleOneTapConfig || {};
  if (!config.enabled || config.customerAuthenticated || config.designMode) return;

  function promptLocale() {
    return String(config.locale || document.documentElement.lang || 'en')
      .toLowerCase()
      .split(/[-_]/)[0] || 'en';
  }

  var locale = promptLocale();
  var isArabic = locale === 'ar';
  var DISMISSED_KEY = 'alasil:google-signin-prompt-dismissed-until';
  var DISMISS_DURATION = 7 * 24 * 60 * 60 * 1000;
  var positionCleanup = null;

  function storage() {
    try { return window.localStorage; } catch (_) { return null; }
  }

  function wasDismissed() {
    var store = storage();
    if (!store) return false;
    try { return Number(store.getItem(DISMISSED_KEY)) > Date.now(); } catch (_) { return false; }
  }

  function markDismissed() {
    var store = storage();
    if (!store) return;
    try { store.setItem(DISMISSED_KEY, String(Date.now() + DISMISS_DURATION)); } catch (_) {}
  }

  function markPhase(name) {
    try {
      if (window.performance && typeof window.performance.mark === 'function') {
        window.performance.mark('alasil:' + name);
      }
      document.dispatchEvent(new CustomEvent('alasil:google-signin-prompt-phase', { detail: { phase: name } }));
    } catch (_) {}
  }

  function currentReturnTo() {
    return (window.location.pathname || '/')
      + (window.location.search || '')
      + (window.location.hash || '');
  }

  function showSigningIn() {
    if (!document.body || document.getElementById('AlAsilGoogleSigningIn')) return;
    var overlay = document.createElement('div');
    overlay.id = 'AlAsilGoogleSigningIn';
    overlay.className = 'google-signin-transition';
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-live', 'polite');
    overlay.setAttribute('dir', isArabic ? 'rtl' : 'ltr');

    var status = document.createElement('span');
    status.className = 'google-signin-transition__status';
    var spinner = document.createElement('span');
    spinner.className = 'google-signin-transition__spinner';
    spinner.setAttribute('aria-hidden', 'true');
    status.appendChild(spinner);
    status.appendChild(document.createTextNode(isArabic ? 'جارٍ تسجيل الدخول…' : 'Signing you in…'));
    overlay.appendChild(status);
    document.body.appendChild(overlay);
  }

  function redirectWithShopify() {
    var coordinator = window.AlAsilAuthReturn;
    if (!coordinator || typeof coordinator.buildLoginUrl !== 'function') return false;

    coordinator.claim(coordinator.OWNER_ACCOUNT);
    var loginUrl = coordinator.buildLoginUrl(
      config.loginBase,
      currentReturnTo(),
      config.locale,
      { acrValues: 'provider:google' }
    );
    markPhase('shopify_redirect_started');
    try { window.AlAsilAnalyticsAuthStarted?.(); } catch (_) {}
    window.location.assign(loginUrl);
    return true;
  }

  function beginSignIn() {
    showSigningIn();
    if (redirectWithShopify()) return;
    document.addEventListener('alasil:auth-return-ready', redirectWithShopify, { once: true });
  }

  function googleMark() {
    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icon.setAttribute('viewBox', '0 0 18 18');
    icon.setAttribute('aria-hidden', 'true');
    icon.classList.add('google-signin-prompt__google-mark');
    icon.innerHTML = '<path fill="#4285F4" d="M17.64 9.205c0-.638-.057-1.252-.164-1.841H9v3.482h4.844a4.14 4.14 0 0 1-1.797 2.716v2.258h2.909c1.702-1.567 2.684-3.875 2.684-6.615Z"/><path fill="#34A853" d="M9 18c2.43 0 4.468-.806 5.956-2.18l-2.91-2.258c-.805.54-1.834.86-3.046.86-2.344 0-4.328-1.584-5.037-3.71H.956v2.333A9 9 0 0 0 9 18Z"/><path fill="#FBBC05" d="M3.963 10.712A5.41 5.41 0 0 1 3.682 9c0-.594.102-1.172.28-1.712V4.955H.957A9 9 0 0 0 0 9c0 1.452.347 2.827.956 4.045l3.007-2.333Z"/><path fill="#EA4335" d="M9 3.578c1.321 0 2.507.454 3.44 1.345l2.582-2.582C13.464.891 11.426 0 9 0A9 9 0 0 0 .956 4.955l3.007 2.333C4.672 5.162 6.656 3.578 9 3.578Z"/>';
    return icon;
  }

  function closePrompt(prompt) {
    markDismissed();
    if (positionCleanup) positionCleanup();
    document.body.classList.remove('google-signin-prompt-open');
    prompt.classList.add('is-leaving');
    prompt.addEventListener('animationend', function () { prompt.remove(); }, { once: true });
    window.setTimeout(function () {
      if (prompt.parentNode) prompt.remove();
    }, 240);
    markPhase('localized_prompt_dismissed');
  }

  function fixedControls() {
    return [
      document.querySelector('.mobile-bottom-menu'),
      document.getElementById('sticky-cart')
    ].filter(Boolean);
  }

  function fixedControlBottom(controls) {
    var bottom = 12;
    controls.forEach(function (control) {
      var style = window.getComputedStyle(control);
      var rect = control.getBoundingClientRect();
      // Reserve the mobile navigation's layout height even while an overlay
      // fades/scales it out. Measuring that transition as zero left the prompt
      // at 12px after close: no resize event fires when opacity returns to 1.
      if (control.matches('.mobile-bottom-menu') && style.display !== 'none' && control.offsetHeight > 0) {
        bottom = Math.max(bottom, control.offsetHeight + Math.max(0, parseFloat(style.bottom) || 0) + 12);
        return;
      }
      var visible = style.display !== 'none'
        && style.visibility !== 'hidden'
        && Number(style.opacity || 1) > 0.01
        && rect.width > 0
        && rect.height > 0
        && rect.top < window.innerHeight
        && rect.bottom > 0;
      if (visible) bottom = Math.max(bottom, window.innerHeight - rect.top + 12);
    });
    return Math.ceil(bottom);
  }

  function primeFixedPosition(prompt) {
    if (window.innerWidth <= 749) {
      prompt.style.setProperty('--google-signin-prompt-bottom', fixedControlBottom(fixedControls()) + 'px');
    }
  }

  function keepClearOfFixedControls(prompt) {
    var controls = fixedControls();

    function sync() {
      if (window.innerWidth > 749) {
        prompt.style.removeProperty('--google-signin-prompt-bottom');
        return;
      }

      var nextBottom = fixedControlBottom(fixedControls()) + 'px';
      if (prompt.style.getPropertyValue('--google-signin-prompt-bottom') !== nextBottom) {
        prompt.style.setProperty('--google-signin-prompt-bottom', nextBottom);
      }
    }

    var mutationObserver = typeof MutationObserver === 'function'
      ? new MutationObserver(sync)
      : null;
    var resizeObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver(sync)
      : null;

    controls.forEach(function (control) {
      if (mutationObserver) mutationObserver.observe(control, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      if (resizeObserver) resizeObserver.observe(control);
    });
    if (resizeObserver) resizeObserver.observe(prompt);
    window.addEventListener('resize', sync, { passive: true });
    document.addEventListener('transitionend', sync, true);
    sync();

    var cleanup = function () {
      document.removeEventListener('transitionend', sync, true);
      window.removeEventListener('resize', sync);
      if (mutationObserver) mutationObserver.disconnect();
      if (resizeObserver) resizeObserver.disconnect();
      positionCleanup = null;
    };
    cleanup.sync = sync;
    return cleanup;
  }

  function renderPrompt() {
    if (wasDismissed() || !document.body || document.getElementById('AlAsilGoogleSignInPrompt')) return;

    var prompt = document.createElement('aside');
    prompt.id = 'AlAsilGoogleSignInPrompt';
    prompt.className = 'google-signin-prompt';
    prompt.setAttribute('role', 'region');
    prompt.setAttribute('dir', isArabic ? 'rtl' : 'ltr');
    prompt.setAttribute('aria-labelledby', 'AlAsilGoogleSignInTitle');

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'google-signin-prompt__close';
    close.setAttribute('aria-label', config.closeLabel || (isArabic ? 'إغلاق' : 'Close'));
    close.textContent = '\u00d7';
    close.addEventListener('click', function () { closePrompt(prompt); });

    var copy = document.createElement('div');
    copy.className = 'google-signin-prompt__copy';
    var title = document.createElement('strong');
    title.id = 'AlAsilGoogleSignInTitle';
    title.className = 'google-signin-prompt__title';
    title.textContent = config.title || (isArabic ? 'سجّل الدخول لإتمام الشراء أسرع' : 'Sign in for faster checkout');
    copy.appendChild(title);

    var action = document.createElement('button');
    action.type = 'button';
    action.className = 'google-signin-prompt__action';
    action.appendChild(googleMark());
    var actionText = document.createElement('span');
    actionText.textContent = config.actionLabel || (isArabic ? 'المتابعة باستخدام Google' : 'Continue with Google');
    action.appendChild(actionText);
    action.addEventListener('click', beginSignIn);

    prompt.appendChild(close);
    prompt.appendChild(copy);
    prompt.appendChild(action);
    document.body.classList.add('google-signin-prompt-open');
    /* Enter at the final collision-free offset. Correcting `bottom` only
       after append caused a visible jump and a measurable mobile CLS. */
    primeFixedPosition(prompt);
    document.body.appendChild(prompt);
    var clearPosition = keepClearOfFixedControls(prompt);
    // Optional login must yield to shopping, search, and other modal tasks.
    function syncOverlayVisibility() {
      var blocked = Array.prototype.some.call(
        document.querySelectorAll('[role="dialog"], [aria-modal="true"], dialog, cart-drawer.active, #SearchSheet.is-open'),
        function (element) {
          var style = window.getComputedStyle(element);
          return style.display !== 'none' && style.visibility !== 'hidden'
            && element.getClientRects().length > 0;
        }
      );
      if (!blocked) clearPosition.sync();
      if (prompt.hidden !== blocked) prompt.hidden = blocked;
      document.body.classList.toggle('google-signin-prompt-open', !blocked);
    }
    var overlayObserver = new MutationObserver(syncOverlayVisibility);
    overlayObserver.observe(document.body, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-hidden', 'aria-modal']
    });
    syncOverlayVisibility();
    positionCleanup = function () {
      overlayObserver.disconnect();
      clearPosition();
    };
    markPhase('localized_prompt_ready');
  }

  // Wait for intent, then give the shopper eight seconds before inviting login.
  function schedulePrompt(event) {
    if (!event.isTrusted) return;
    ['pointerdown', 'keydown', 'scroll'].forEach(function (type) {
      window.removeEventListener(type, schedulePrompt);
    });
    window.setTimeout(function () {
      if (wasDismissed() || !config.stylesheetUrl || typeof window.__loadStylesheet !== 'function') return;
      // Keep optional login UI out of first paint and never append it unstyled.
      // The regular account entry remains available if this stylesheet fails.
      window.__loadStylesheet(config.stylesheetUrl).then(renderPrompt, function () {});
    }, 8000);
  }
  if (!wasDismissed()) {
    ['pointerdown', 'keydown', 'scroll'].forEach(function (type) {
      window.addEventListener(type, schedulePrompt, { passive: true });
    });
  }
})(window, document);
